export enum IBundleImageName {
  bundleGuide = 'bundle_guide',
  bundleGuideMe = 'bundle_guide_me',
  coach = 'coach',
  pro = 'pro',
}
